<template>
  <div :class="{component: true, disabled: loading, 'component--box': true}">
    <div class="component__inner">
      <Loading :show="loading" />
      <div>
        <label>Förnamn</label>
        <input type="text" placeholder="Förnamn" v-model="user.name1" />
      </div>
      <div>
        <label>Efternamn</label>
        <input type="text" placeholder="Efternamn" v-model="user.name2" />
      </div>
      <div class="wide">
        <label>Gatuadress</label>
        <input type="text" placeholder="Gatuadress" v-model="user.addr1" />
      </div>
      <div>
        <label>Postnummer</label>
        <input type="text" placeholder="Postnummer" v-model="user.addr3" />
      </div>
      <div>
        <label>Stad</label>
        <input type="text" placeholder="Stad" v-model="user.addr4" />
      </div>
      <div style="width:100%;height:1rem"></div>
      <div class="wide">
        <label>Land</label>
        <select v-model="user.addr5">
          <option v-for="option in filteredCountries" v-bind:key="option.value" v-bind:value="option.value">{{ option.title }}</option>
        </select>
      </div>
      <div style="width:100%;height:1rem"></div>
      <div class="wide">
        <label>Telefonnummer</label>
        <input type="tel" placeholder="Telefonnummer" v-model="user.mobile_phone" />
      </div>
      <div class="wide">
        <label>E-postadress</label>
        <input type="email" placeholder="E-postadress" v-model="user.email" />
      </div>
      <div class="center wide">
        <p class="error-message" v-if="errorMessage">{{errorMessage}}</p>
      </div>
      <div class="center wide">
        <button class="button--rounded" @click="save()">Spara</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  data() {
    return {
      orders: [],
      user: {},
      loading: false,
      errorMessage: '',
      countries: [],
    };
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    filteredCountries() {
      const countries = this.countries.filter(country => country.value !== '----');

      const match = countries.filter(country => country.value === this.user.addr5);

      if (match.length) {
        return countries;
      }

      countries.push({
        value: '',
        title: '[ Inget valt ]',
      });

      return countries;
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    async fetch() {
      this.loading = true;
      const { user } = await API.get('/account/user');
      if (user) {
        this.user = user;
      }
      this.loading = false;
    },
    async save() {
      this.loading = true;
      const { success, errorMessage } = await API.post('/account/update', this.user);
      if (!success) {
        this.errorMessage = errorMessage;
      } else {
        this.errorMessage = '';

        this.openModal(['GeneralModal', {
          title: 'Sparat',
          content: 'Dina uppgifter har sparats.',
        }]);
      }

      this.loading = false;
    },
    async fetchCountries() {
      const data = await API.get('countries');
      this.countries = data;
    },
  },
  mounted() {
    this.fetch();
    this.fetchCountries();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
@import '~@/global-v2.styl'

.component
  background-color white
  padding: 2rem
  padding-top 3rem
  width: 100%
  display: block

  .component__inner
    max-width 539px
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content space-between
    & > div
      width 48%
      margin-bottom: 1.5rem
      +max-xs-mobile()
        width: 100% !important
      &.wide
        width 100%
    label
      v2-label()

.disabled
  disabled-grey()

input[type="text"], input[type="email"], input[type="tel"], select
  v2-input()

.error-message
  margin-top 10px
  margin-bottom 10px
</style>



// WEBPACK FOOTER //
// MyPageDetails.vue?3852c8f2